import Head from 'next/head';
import { ArticlesList } from '../components';
import { withLayout } from '../Layout/Layout';
import { DestinationList } from '../components';
import { styled } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { useState, useEffect, createRef } from 'react';
import { createTheme, ThemeProvider } from '@mui/material';
import * as PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useRouter } from 'next/router';

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    variant="scrollable"
    scrollButtons="auto"
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    width: '100%',
    backgroundColor: 'transparent',
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: '1.25rem',
    fontFamily: 'PPFragment, serif',
    color: '#ffffff',
    '&.Mui-selected': {
      color: '#ffffff',
      textDecoration: 'underline',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'transparent',
    },
    '&.MuiButtonBase-root': {
      padding: 16,
      height: 60,
      maxHeight: 60,
      minHeight: 60,
      maxWidth: '440px',
      fontSize: '1.25rem',
    },
    [theme.breakpoints.down('md')]: {
      '&.MuiButtonBase-root': {
        fontSize: '1.25rem',
      },
    },
  })
);
const tabsTheme = createTheme({
  palette: {
    primary: {
      main: '#202020',
    },
    secondary: {
      main: '#202020',
    },
  },
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function Destinations() {
  const { query } = useRouter();
  const router = useRouter();
  const [tab, setTab] = useState(0);
  const handleChange = (event, newValue) => {
    router.push(
      {
        pathname: '/destinations',
        query: { tab: newValue === 1 ? 'articles' : 'destinations' },
      },
      undefined,
      { shallow: true }
    );
    setTab(newValue);
  };
  const tabsRef = createRef();

  useEffect(() => {
    if (query) {
      if (query.tab === 'articles') {
        setTab(1);
      }
    }
  }, [query]);

  return (
    <div className="relative">
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/destinations`} />
        <meta
          name="description"
          content={
            "Explore the world's top travel destinations on First-Class.com. Discover the beauty, culture, and attractions of sought-after places around the globe"
          }
        />
        <title>Destinations: Discover Dream Travel Locations</title>
      </Head>
      <ThemeProvider theme={tabsTheme}>
        <Box
          className="container mt-8"
          sx={{
            borderBottom: 1,
            borderTop: 1,
            borderColor: '#fff',
            position: 'absolute',
            top: '70px',
            [tabsTheme.breakpoints.down('lg')]: {
              top: '0',
            },
            zIndex: 10,
            left: 0,
            right: 0,
          }}
          ref={tabsRef}
        >
          <StyledTabs value={tab} onChange={handleChange}>
            <StyledTab label="Destinations" {...a11yProps(0)} />
            <StyledTab label="Destination articles" {...a11yProps(1)} />
          </StyledTabs>
        </Box>
        <TabPanel value={tab} index={0}>
          <div>
            <DestinationList heading="Destinations" />
          </div>
        </TabPanel>
        <TabPanel value={tab} index={1}>
          <div
            style={{
              borderTop: '80px solid #385179',
              boxSizing: 'content-box',
            }}
          >
            <ArticlesList type="Destinations" heading="Destination articles" />
          </div>
        </TabPanel>
      </ThemeProvider>
    </div>
  );
}

export default withLayout(Destinations, true);
